<template>
  <div>
    <add-equipo
      :listCategoriasAdmin="listCategoriasAdmin"
      :equipo="dataEquipo"
      :equipoAux="dataEquipoAux"
      :institucion="institucionSeleccionada"
      @agregarEquipo="agregarEquipo"
      :accion="accion"
    ></add-equipo>
    <b-row>
      <b-col md="5">
        <b-card no-body class="p-1">
          <b-row>
            <b-col
              md="3"
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.CALIFICACION
              "
            >
              <b-button
                v-b-tooltip.hover.v-primary
                title="Crear Institución"
                variant="flat-primary"
                class="btn-icon"
                @click="showNewInstitucion"
              >
                <feather-icon size="22" icon="PlusSquareIcon" />
              </b-button>
            </b-col>
            <b-col
              :md="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.CALIFICACION
                  ? '9'
                  : '12'
              "
              style="margin-top:5px"
              class="mb-1"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input placeholder="Buscar" v-model="search" />
              </b-input-group>
            </b-col>
          </b-row>
          <b-overlay
            :show="showLoadingIns"
            rounded="sm"
            :class="[showLoadingIns ? 'mt-5' : 'mt-0', '']"
          >
            <b-list-group style="height:65vh; overflow:scroll">
              <b-list-group-item
                class="d-flex"
                button
                v-for="item in listInstitucionesFilter"
                :key="item.id"
              >
                <item-institucion
                  :item="item"
                  @updateInstitucion="updateInstitucion($event)"
                  @getEquiposInstitucion="getEquiposInstitucion($event)"
                  @eliminarInstitucion="eliminarInstitucion($event)"
                  @updateEstado="updateEstado($event)"
                ></item-institucion>
                <!-- <b-form-checkbox
                  v-model="item.is_activo"
                  :disabled="
                    USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION
                      ? false
                      : true
                  "
                >
                </b-form-checkbox>
                <div style="width: 100%;" @click="getEquiposInstitucion(item)">
                  <img width="25" :src="item.foto" alt="" class="ml-1" />
                  <span class="ml-1" style="text-transform: capitalize">{{
                    item.nombre
                  }}</span>

                  <b-button
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.CALIFICACION
                    "
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-danger"
                    class="btn-icon"
                    style="float:right;"
                    size="sm"
                    @click="eliminarInstitucion(item)"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                  <b-button
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.CALIFICACION
                    "
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat"
                    class="btn-icon"
                    style="float:right;"
                    size="sm"
                    @click="updateInstitucion(item)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                </div> -->
              </b-list-group-item>
            </b-list-group>
          </b-overlay>
        </b-card>
      </b-col>
      <b-col md="7">
        <span class="d-none">{{ limpiaRef }}</span>
        <b-card no-body class="p-1">
          <b-overlay :show="showLoadingEquipos" rounded="sm">
            <b-row v-if="institucionSeleccionada.apodo != null">
              <b-col md="8">
                <img :src="institucionSeleccionada.foto" alt="nd" width="40" />
                <b class="ml-1" style="text-transform: capitalize">{{
                  institucionSeleccionada.nombre
                }}</b></b-col
              >
              <b-col
                style="text-align:center"
                md="4"
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION
                "
              >
                <b-button
                  v-b-tooltip.hover.v-primary
                  title="Agregar equipos a categorias sin equipo"
                  variant="flat-primary"
                  class="btn-icon d-none"
                  size="sm"
                  @click="
                    getListCategoriasUsadasNoUsadas(
                      institucionSeleccionada.id_institucion
                    )
                  "
                >
                  <feather-icon size="22" icon="LayersIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.v-primary
                  title="Agregar equipo individual"
                  variant="flat-primary"
                  size="sm"
                  class="btn-icon"
                  @click="getListCategoriasAdmin('i', {})"
                >
                  <feather-icon size="22" icon="PlusIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.v-primary
                  title="Guardar cambios"
                  size="sm"
                  variant="flat-primary"
                  class="btn-icon"
                  @click="saveEquipos(institucionSeleccionada.id_institucion)"
                >
                  <feather-icon size="22" icon="SaveIcon" />
                </b-button>
              </b-col>
            </b-row>
            <hr />
            <div
              v-for="item in listCategoriasUsadasNoUsadas"
              :key="item.id_equipo"
              :style="item.id_equipo == null ? 'color:#ababab' : 'color:black'"
            >
              <b-row class="align-items-baseline">
                <b-col md="1">
                  <b-form-checkbox
                    v-model="item.estado"
                    :disabled="
                      USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.CALIFICACION
                        ? false
                        : true
                    "
                  >
                  </b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <span>{{ item.disciplina }} {{ item.categoria }} </span>
                </b-col>
                <b-col md="5">
                  <b-form-group label="" label-for="phone">
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        {{ institucionSeleccionada.apodo }}
                      </b-input-group-prepend>
                      <cleave
                        :disabled="
                          USER().rol === ROLES.SUPER ||
                          USER().rol === ROLES.ADMIN ||
                          USER().rol === ROLES.CALIFICACION
                            ? false
                            : true
                        "
                        id="phone"
                        v-model="item.alias_equipo"
                        class="form-control"
                        :raw="false"
                        :options="opt"
                        placeholder="Distintivo"
                        style="textTransform: uppercase"
                        :style="
                          item.id_equipo == null
                            ? 'color:#ababab'
                            : 'color:black'
                        "
                        @blur="keyUpAlias(item)"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-button
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.CALIFICACION
                    "
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-danger"
                    class="btn-icon"
                    size="sm"
                    @click="getListCategoriasAdmin('u', item)"
                  >
                    <feather-icon icon="ShuffleIcon" />
                  </b-button>
                  <b-button
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.CALIFICACION
                    "
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-danger"
                    class="btn-icon"
                    size="sm"
                    @click="eliminarEquipo(item)"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                  <b-button
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.CALIFICACION
                    "
                    :id="`pop_info_equipo${item.id_equipo}`"
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-warning"
                    class="btn-icon"
                    size="sm"
                  >
                    <feather-icon icon="InfoIcon" />
                  </b-button>
                  <b-popover
                    ref="popover"
                    :target="`pop_info_equipo${item.id_equipo}`"
                    triggers="hover"
                    :show.sync="popoverShowIA[item.id_equipo]"
                    placement="auto"
                    container="my-container"
                  >
                    <template v-slot:title>
                      <div>
                        <span>Detalle de cambios</span>
                      </div>
                    </template>
                    <div style="max-height: 350px; overflow-y: auto;">
                      <div
                        style="background:#ececec;margin-top:10px; padding:4px;"
                      >
                        <span style="font-size:11px;font-weight: bold;"
                          >{{ item.fecha_creacion }} </span
                        ><br /><span style="font-size:12px">Creada</span>
                        <br />
                        <span style="font-size:12px;font-weight: bold">{{
                          item.usuario
                        }}</span>
                      </div>
                      <div
                        style="background:#ececec;margin-top:10px; padding:4px;"
                        v-for="item2 in item.movimientos"
                        :key="item2.id"
                      >
                        <span style="font-size:11px;font-weight: bold;"
                          >{{ item2.fecha }} </span
                        ><br /><span style="font-size:12px">{{
                          item2.accion
                        }}</span>
                        <br />
                        <span style="font-size:12px;font-weight: bold">{{
                          item2.usuario
                        }}</span>
                      </div>
                    </div>
                  </b-popover>
                </b-col>
              </b-row>
            </div>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard,
  BButton,
  BRow,
  BCol,
  BListGroup,
  BListGroupItem,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  VBTooltip,
  BInputGroupPrepend,
  BOverlay,
  BInputGroup,
  BPopover,
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import { URL, USER, ROLES } from '../../utils/variables'
import AddEquipo from './AddEquipo.vue'
import ItemInstitucion from './ItemInstitucion.vue'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroupPrepend,
    AddEquipo,
    BOverlay,
    ItemInstitucion,
    BInputGroup,
    Cleave,
    BPopover,
  },
  props: {
    listInstituciones: Array,
    showLoadingIns: Boolean,
    limpiarDerecha: Boolean,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup(props, { emit }) {
    const listCategoriasUsadasNoUsadas = ref([])
    const listCategoriasUsadasAuxiliar = ref([])
    const listCategoriasNoUsadas = ref([])
    const listCategoriasAdmin = ref([])
    const institucionSeleccionada = ref({ foto: '', apodo: null })
    const showLoadingEquipos = ref(false)
    const popoverShowIA = ref([])
    const search = ref('')
    const dataEquipoAux = ref({})
    const accion = ref('i')
    const opt = ref({
      blocks: [100],
    })
    const { getApi, postApi } = apiCall()
    const dataEquipo = {
      label: '',
      value: '',
    }
    // watch(limpiaRef.value, (current, prev) => {
    //   console.log(`watch => current: ${current} prev: ${prev}`)
    // })
    const limpiaRef = computed(
      // eslint-disable-next-line
      () => {
        if (props.limpiarDerecha) {
          institucionSeleccionada.value = { foto: '', apodo: null }
          listCategoriasUsadasNoUsadas.value = []
        }
        // eslint-disable-next-line
        // return props.limpiarDerecha
        // eslint-disable-next-line
      }
    )
    const listInstitucionesFilter = computed(
      () =>
        // eslint-disable-next-line
        props.listInstituciones.filter(
          player =>
            // eslint-disable-next-line
            player.nombre.toLowerCase().includes(search.value.toLowerCase())
          // eslint-disable-next-line
        )
      // eslint-disable-next-line
    )
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )
    watch(cambioTorneo, data => {
      emit('changeTorneo', data)
    })

    function existeRepetidosTodo() {
      const categoriasRepetidas = {}
      let existe = false
      // Recorremos el array para verificar repeticiones
      listCategoriasUsadasNoUsadas.value.forEach(item => {
        // Creamos una clave única combinando id_categoria y alias_equipo
        const clave = `${item.id_categoria}-${item.alias_equipo}`
        // Si la clave ya existe en el objeto categoriasRepetidas, significa que el elemento se repite
        if (categoriasRepetidas[clave]) {
          existe = true
        } else {
          // Si no existe, agregamos la clave al objeto categoriasRepetidas
          categoriasRepetidas[clave] = true
        }
      })
      return existe
    }
    function existeEquipoRepetido(item) {
      // console.log(item)
      // console.log(listCategoriasUsadasNoUsadas.value)
      let existe = true
      const found = listCategoriasUsadasNoUsadas.value.findIndex(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.id_categoria === item.id_categoria &&
          // eslint-disable-next-line
          element.alias_equipo.toUpperCase() ===
            item.alias_equipo.toUpperCase() &&
          // eslint-disable-next-line
          element.pos !== item.pos
        // eslint-disable-next-line
      )
      if (found === -1) {
        existe = false
      }
      return existe
    }
    function keyUpAlias(item) {
      // console.log(item)
      const found = existeEquipoRepetido(item)
      if (found) {
        listCategoriasUsadasNoUsadas.value[item.pos].alias_equipo = ''
      }
    }
    async function updateEstado(item) {
      const path = 'ApiConfiguration/updateEstadoInstitucion'
      const data = {
        id_institucion: item.item.id_institucion,
        estado: item.is_activo ? 'a' : 'd',
      }
      await postApi(URL, path, data)
    }
    async function eliminarInstitucion(item) {
      const path = 'ApiConfiguration/deleteInstitucion'
      const dataDelete = {
        idInstitucion: item.id_institucion,
        escudo: item.escudo,
      }
      const data = await postApi(URL, path, dataDelete)
      // console.log(data)
      if (data === null) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title:
                'ERROR, existe multiple información asociada al elemento. Acción no permitida',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          }
        )
      } else if (data !== null) {
        // showConfirmacionEliminar.value = false
        if (data.flag === 'si') {
          const found = props.listInstituciones.findIndex(
            // eslint-disable-next-line
            element => element.id_institucion === dataDelete.idInstitucion
          )
          props.listInstituciones.splice(found, 1)

          emit('limpiaDerecha', true)
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'INSTITUCION eliminada exitosamente',
                icon: 'CheckIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'ERROR no se pudo eliminar',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        }
      }
    }

    // function eliminarInstitucion() {
    //   console.log('elimina')
    // }
    async function getEquiposInstitucion(item) {
      showLoadingEquipos.value = true
      emit('limpiaDerecha', false)
      // props.limpiarDerecha = false
      institucionSeleccionada.value = item
      listCategoriasUsadasNoUsadas.value = []
      const path = `ApiConfiguration/getEquipos/${item.id_institucion}`
      const data = await getApi(URL, path)
      listCategoriasUsadasNoUsadas.value = data.data
      listCategoriasUsadasAuxiliar.value = data.auxiliar
      listCategoriasUsadasNoUsadas.value.forEach((element, index) => {
        element.pos = index
      })
      // console.log(listCategoriasUsadasNoUsadas.value)
      showLoadingEquipos.value = false
    }
    async function updateCategoria(item) {
      // console.log(item)
      let cambio = ''
      if (item.id_categoria !== dataEquipoAux.value.id_categoria) {
        cambio += `cambia categoria equipo ${dataEquipoAux.value.apodo} de ${dataEquipoAux.value.disciplina} ${dataEquipoAux.value.categoria}  a ${item.categoria}`
      }
      const dataSend = {
        equipo: item,
        idUser: USER().id_usuario,
        cambios: cambio,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const path = 'ApiConfiguration/updateCategoria/'
      const response = await postApi(
        URL,
        path,
        // eslint-disable-next-line
        dataSend
      )
      // console.log(response)
      if (response.flag === 'si') {
        getEquiposInstitucion(institucionSeleccionada.value)
        store.commit('someVariables/UPDATE_SHOW_NEW_EQUIPO', false)
        dataEquipoAux.value = {}
      }
    }
    function agregarEquipo(item) {
      // console.log(item)
      // console.log(accion.value)
      const itemEquipo = {
        disciplina: item.categoria.disciplina,
        alias_equipo: item.alias_equipo || '',
        categoria: item.categoria.categoria,
        id_categoria: item.categoria.id_categoria,
        id_disciplina: item.categoria.id_disciplina,
        id_equipo: null,
        estado: false,
        pos: listCategoriasUsadasNoUsadas.value.length,
      }
      if (accion.value === 'i') {
        const found = existeEquipoRepetido(itemEquipo)
        if (!found) {
          listCategoriasUsadasNoUsadas.value.push(itemEquipo)
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Agregado con exito',
                icon: 'CheckIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title:
                  'Ingresa un distintivo al equipo para poder diferenciarlo en la categoria seleccionada. El equipo ya existe',
                icon: 'CheckIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        }
      } else if (accion.value === 'u') {
        const found = existeEquipoRepetido(itemEquipo)
        if (!found) {
          // console.log('en update')
          itemEquipo.id_equipo = item.categoria.id_equipo
          updateCategoria(itemEquipo)
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title:
                  'Ya existe un equipo con el mismo nombre en la categoria seleccionada, porfavor agregue un distintivo a cualquier equipo para diferenciarlos',
                icon: 'CheckIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        }
        // console.log(found)
      }
    }
    async function getListCategoriasUsadasNoUsadas(idInstitucion) {
      const lista = listCategoriasUsadasNoUsadas.value.filter(
        // eslint-disable-next-line
        element => element.id_equipo !== null
      )
      listCategoriasNoUsadas.value = []
      const path = `ApiConfiguration/getCategoriasUsadasDisponibles/${idInstitucion}/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const data = await getApi(URL, path)
      listCategoriasNoUsadas.value = data.data
      // listCategoriasNoUsadas.value.forEach(element => {
      //   element.auxiliar = true
      // })

      const array3 = lista.concat(
        // eslint-disable-next-line
        listCategoriasNoUsadas.value
      )
      // eslint-disable-next-line
      listCategoriasUsadasNoUsadas.value = array3
      listCategoriasUsadasNoUsadas.value.forEach((element, index) => {
        element.pos = index
      })
      // console.log(listCategoriasUsadasNoUsadas.value)
    }

    function showNewInstitucion() {
      // store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', true)
      emit('nueva', props.showLoadingIns)
    }
    function updateInstitucion(item) {
      // store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', true)
      const data = { ...item }
      emit('update', data)
    }
    async function getListCategoriasAdmin(accionString, item) {
      // console.log(item)
      accion.value = accionString
      listCategoriasAdmin.value = []
      dataEquipoAux.value = { ...item }
      const path = `ApiConfiguration/getCategoriasEquipos/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        data.data.forEach(element => {
          const obj = {
            label: `${element.disciplina} ${element.categoria}`,
            value: element.id_categoria,
            id_disciplina: element.id_disciplina,
            disciplina: element.disciplina,
            categoria: element.categoria,
            id_categoria: element.id_categoria,
            id_equipo: item.id_equipo,
          }
          if (accionString === 'u') {
            if (
              element.agrupar === item.agrupar &&
              item.id_categoria !== element.id_categoria
            ) {
              listCategoriasAdmin.value.push(obj)
            }
          } else {
            listCategoriasAdmin.value.push(obj)
          }
        })
      } else {
        listCategoriasAdmin.value = []
      }
      // console.log(listCategoriasAdmin)
      store.commit('someVariables/UPDATE_SHOW_NEW_EQUIPO', true)
    }
    function verificarCambiosEquipos() {
      const cambios = []
      listCategoriasUsadasAuxiliar.value.forEach((element, index) => {
        let cambio = ''
        const elementFind = listCategoriasUsadasNoUsadas.value[index]
        if (element.alias_equipo !== elementFind.alias_equipo) {
          cambio += `cambia nombre equipo de ${element.disciplina} ${
            element.categoria
          } ${element.apodo} ${element.alias_equipo} a ${element.disciplina} ${
            element.categoria
          } ${element.apodo} ${elementFind.alias_equipo.toUpperCase()}`
        }
        if (element.estado !== elementFind.estado) {
          cambio += `cambia estado equipo  ${element.disciplina} ${
            element.categoria
          } ${element.apodo} ${element.alias_equipo}  a:  ${
            elementFind.estado ? 'activo' : 'inactivo'
          }`
        }
        if (cambio !== '') {
          const send = {
            idUser: USER().id_usuario,
            idEquipo: element.id_equipo,
            movimiento: cambio,
          }
          cambios.push(send)
        }
      })
      return cambios
    }

    async function saveEquipos(idInstitucion) {
      // console.log(listCategoriasUsadasNoUsadas.value)
      //  showLoading.value = true

      const dataSend = {
        listEquipos: listCategoriasUsadasNoUsadas.value,
        idUser: USER().id_usuario,
        cambios: verificarCambiosEquipos(),
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      if (existeRepetidosTodo()) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ERROR, Existen equipos repetidos',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          }
        )
      } else {
        const path = `ApiConfiguration/insertUpdateEquipos/${idInstitucion}`
        const response = await postApi(
          URL,
          path,
          // eslint-disable-next-line
          dataSend
        )
        // console.log(response)
        if (response.flag === 'si') {
          getEquiposInstitucion(institucionSeleccionada.value)
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'EQUIPOS actualizados exitosamente',
                icon: 'CheckIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'ERROR, no se pudo actualizar',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        }
      }

      // showLoading.value = false
    }
    async function eliminarEquipo(item) {
      const path = 'ApiConfiguration/deleteEquipo'
      // console.log(item)
      const dataDelete = {
        idEquipo: item.id_equipo,
      }
      // console.log(dataDelete)
      if (dataDelete.idEquipo !== null) {
        const data = await postApi(URL, path, dataDelete)
        if (data === null) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title:
                  'ERROR, existe multiple información asociada al elemento. Acción no permitida',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            }
          )
        } else if (data !== null) {
          // showConfirmacionEliminar.value = false
          if (data.flag === 'si') {
            // const found = props.listInstituciones.findIndex(
            //   // eslint-disable-next-line
            //   element => element.id_institucion === dataDelete.idInstitucion
            // )
            // props.listInstituciones.splice(found, 1)

            // emit('limpiaDerecha', true)
            getEquiposInstitucion(institucionSeleccionada.value)
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'EQUIPO eliminado exitosamente',
                  icon: 'CheckIcon',
                  variant: 'success',
                  solid: true,
                },
              },
              {
                position: 'top-center',
                // eslint-disable-next-line
              }
            )
          } else {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'ERROR no se pudo eliminar',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  solid: true,
                },
              },
              {
                position: 'top-center',
                // eslint-disable-next-line
              }
            )
          }
        }
      } else {
        listCategoriasUsadasNoUsadas.value.splice(item.pos, 1)
        listCategoriasUsadasNoUsadas.value.forEach((element, index) => {
          element.pos = index
        })
      }
    }
    return {
      showNewInstitucion,
      getListCategoriasUsadasNoUsadas,
      getEquiposInstitucion,
      listCategoriasUsadasNoUsadas,
      listCategoriasAdmin,
      getListCategoriasAdmin,
      agregarEquipo,
      dataEquipo,
      institucionSeleccionada,
      saveEquipos,
      eliminarInstitucion,
      limpiaRef,
      showLoadingEquipos,
      updateInstitucion,
      listInstitucionesFilter,
      search,
      USER,
      ROLES,
      eliminarEquipo,
      updateEstado,
      keyUpAlias,
      opt,
      popoverShowIA,
      accion,
      dataEquipoAux,
    }
  },
}
</script>
